import React from "react";
import Headline from "./Headline";
import { Button, Col, Flex, Form, FormInstance, Input, notification, Row, Select } from "antd";
import ContactUsApi from "../../api-services/contact-us-api.service";
import HomeLink from "../../widgets/HomeLink";
import Cookies from "js-cookie"
import ListApi from "../../api-services/list-api.service";

const { TextArea } = Input;

const customCookies = Cookies.withAttributes({
  expires: 14
});

const bannerPath = '/iceholidays-assets/images/mice-banner.png';
const breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'MICE' }
] 

const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '${label} is not a valid email!',
    number: '${label} is not a valid number!',
  },
  number: {
    range: '${label} must be between ${min} and ${max}',
  },
};

const storedArray$ = (array) => Promise.resolve(JSON.parse(array));
const miceLogoPath = '/iceholidays-assets/images/mice-logo-new.png';

export default class MiceAgentRegistrationPage extends React.Component {
  api = new ContactUsApi;
  listApi = new ListApi;
  contactForm = React.createRef<FormInstance>();
  
  state = {
    titles: [],
    states: [],
    cities: [],
    countries: [],
    filteredStates: [],
    filteredCities: [],
    filteredCountries: [],
    selectedState: "",
    selectedCity: "",
    selectedCountry: ""
  }


  componentDidMount() {
    const storedCities = customCookies.get("cities");

    Promise.all([
      this.listApi.getTitles(),
      this.listApi.getCountries(),
      storedCities == undefined ? this.listApi.getCities() : storedArray$(storedCities),
    ]).then(([titles, countries, cities]) => {
        const states = this.listApi.getStatesOptionsByCities(cities);
        customCookies.set('cities', JSON.stringify(cities))

        this.setState({titles, countries, states, cities, filteredStates: states, filteredCities: cities, filteredCountries: countries})
      })
      .catch(error => {
        notification.error({ message: 'Something went wrong.'});
      });
  }

  fetchCities = (searchStr:string) => {
    this.listApi.getCities({term: searchStr})
      .then(filteredCities => this.setState({filteredCities}));
  }


  filterCities = (selectedState) => {
    const storedCities = customCookies.get(`cities-${selectedState}`);
    (storedCities == undefined ? this.listApi.getCities({state: selectedState}) : storedArray$(storedCities))
      .then(filteredCities => {
        customCookies.set(`cities-${selectedState}`, JSON.stringify(filteredCities))
        this.setState({filteredCities, selectedState});
    });
  }

  filterStates = (selectedCity, option) => {
    const {states, countries, selectedCountry} = this.state;
    var filteredStates = states;
    var filteredCountries = countries;

    if(selectedCity){
      filteredStates = states.filter(({value}) => value == option.state)
      filteredCountries = countries.filter(({value}) => value == option.country)
    }else{
      this.getCitiesByCountry(selectedCountry)
    }

    this.setState({filteredStates, filteredCountries, selectedCity})
  }

  changeCountry = (selectedCountry) => {
    this.setState({selectedCountry})

    // if(this.state.selectedCity == ""){
      this.getCitiesByCountry(selectedCountry)
    // }
  }

  getCitiesByCountry(country){
    const storedCitiesByCountry = customCookies.get(`cities-${country}`);
    Promise.all([
      (storedCitiesByCountry == undefined ? this.listApi.getCities({country}) : storedArray$(storedCitiesByCountry)),
    ])
      .then(([cities]) => {
        if(cities.length > 0)  customCookies.set(`cities-${country}`, JSON.stringify(cities))
        this.setState({cities, filteredCities: cities, country})
        
        const states = this.listApi.getStatesOptionsByCities(cities);
        this.setState({states, filterStates: states});
      })
  }

  submitForm(formValues) {
      const form = {
        kind: 'agent_mice_registration',
        company: formValues.companyName,
        name: `${formValues.title} ${formValues.firstName} ${formValues.lastName}`,
        email: formValues.email,
        message: formValues.message,
        phone: formValues.personalPhoneNumber,
        office_number: formValues.officePhoneNumber,
        state: formValues.state,
        city: formValues.city,
        country: formValues.country,
        postcode: formValues.postcode,
        address: formValues.address,
        address2: formValues.address2,
      }
        this.api.contactInquiry(form)
          .then(success => {
            if(success){
              notification['success']({message: "Inquiry sent."});
              this.contactForm.current?.resetFields();
            }
          })
          .catch(error => {
            notification.error({ message: 'An error occured while sending inquiry.'});
          });
    }

  render(){
    const {titles, filteredStates, filteredCities, filteredCountries} = this.state;
    return (
      <div className="mice-page">
        <Headline showSearch={false} bannerImage={bannerPath} breadcrumbs={breadcrumbs}>
          <span className="title">
            <img src={miceLogoPath} alt="MICE Logo" />
          </span>
        </Headline>

        <div className="mice-page_body mice-page_body-forms">
          <div id="header">
            <h1> GD MICE </h1>
            <h4>Custom-Made Travel Solutions For Every Business Need </h4>
            <span>Meetings | Incentives | Conferences | Events</span>
            <p>GD MICE is established to help partners capture growing opportunities in the MICE market.</p>
            <p>We create fully customised corporate and group travel solutions across industries, regions, and business sizes.</p>
            <p>Powered by GD Group Berhad Impact Business Module, GD MICE operates on B2B, B2B2C, and B2C2B models—strengthening partner collaboration, enhancing customer reach, and improving market scalability.</p>
            <p>With the backing of ICE Holidays’ industry experience, financial strength, and strong procurement network, GD MICE delivers:</p>
            <p>Customised programs</p>
            <p>Advantageous cost-performance ratio</p>
            <p>Comprehensive backup support</p>
            <p>Seamless end-to-end arrangements</p>
            <p>From business meetings and incentive trips to conferences and signature group experiences, GD MICE ensures value, reliability, and memorable journeys—supported by our nationwide partner network.</p>
            <p>Please fill out the contact form below to get your quote</p>
          </div>

          <Form
            ref={this.contactForm}
            autoComplete="off"
            layout="vertical"
            variant="filled"
            validateMessages={validateMessages}
            onFinish={(formValues)=>this.submitForm(formValues)}
            className="mice-form"
          >
            <div className="mice-form-group">
              <label>Company Details</label>
              <Row gutter={[16,16]}>
                <Col xs={24} md={12}>
                  <Form.Item label="Company Name" name="companyName" required>
                    <Input placeholder="Enter Company Name" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Job Title" name="jobTitle">
                    <Input placeholder="Enter Job Title" />
                  </Form.Item>
                </Col>
              </Row>
            </div>
            
            <div className="mice-form-group">
              <label>Person In Charge Name</label>
              <Row gutter={[16,16]}>
                <Col xs={24} md={8}>
                  <Form.Item label="Title" name="title" required>
                    <Select placeholder="Mr" options={titles}/>
                  </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                  <Form.Item label="First Name" name="firstName" required>
                    <Input placeholder="Enter First Name" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                  <Form.Item label="Last Name" name="lastName" required>
                    <Input placeholder="Enter Last Name" />
                  </Form.Item>
                </Col>
              </Row>
            </div>

            <div className="mice-form-group">
              <label>Company Address</label>
              <Row gutter={[16,16]}>
                <Col xs={24} md={12}>
                  <Form.Item label="Street Address" name="address" required>
                    <Input placeholder="Enter Address" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Street Address Line 2" name="address2">
                    <Input placeholder="Enter Address 2" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="State" name="state">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Please Select"
                      options={filteredStates}
                      onChange={this.filterCities}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="City" name="city">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Please Select"
                      options={filteredCities}
                      onChange={this.filterStates}
                      // filterOption={false}
                      // onSearch={this.fetchCities}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Postcode" name="postCode">
                    <Input type="number" placeholder="Enter Postcode" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Country" name="country">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Please Select"
                      options={filteredCountries}
                      onChange={this.changeCountry}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Office Phone Number" name="officePhoneNumber" required>
                    <Input placeholder="Enter Office Phone Number" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Personal Phone Number" name="personalPhoneNumber" required>
                    <Input placeholder="Enter Personal Phone Number" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Email" name="email" rules={[{ type: 'email' }]} required>
                    <Input placeholder="Enter Email" />
                  </Form.Item>
                </Col>
              </Row>
            </div>

            <div className="mice-form-group">
              <label>More Details</label>
              <Row gutter={[16,16]}>
                <Col span={24}>
                  <Form.Item label="Message" name="message" required>
                    <TextArea rows={4} placeholder="Write your message"/>
                  </Form.Item>
                </Col>
              </Row>
            </div>

            <Flex align="center" justify="center">
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Flex>
            
          </Form>

        </div>
      </div>
    )
  }
}